import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import {
  GlAccountClassification,
  GlAccountSortField,
  GlAccountType,
  ReportingAccountType,
  SortingOrder,
} from "@/graphql/codegen/graphql"

export const ChartOfAccountsSearchParamsSchema = z.object({
  query: fallback(z.string().optional().default(""), ""),
  field: fallback(z.nativeEnum(GlAccountSortField), GlAccountSortField.Number),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
  classification: z.nativeEnum(GlAccountClassification).optional(),
  accountTypes: z.array(z.nativeEnum(GlAccountType)).optional(),
  reportingAccountType: z.nativeEnum(ReportingAccountType).optional(),
  showInactive: fallback(z.boolean(), false),
})

export type ChartOfAccountsSearchParams = z.infer<typeof ChartOfAccountsSearchParamsSchema>
